import { type AttachmentDto } from './AttachmentDto';
import { type EnumType } from './EnumType';
import { SplashScreenType } from './SplashScreenType';

export type InterfaceAppearanceDto = {
  system_name?: string;
  primary_color?: string;
  sidebar_color?: string;
  background_color?: string;
  logo?: AttachmentDto | null;
  splash_type?: EnumType;
  splash_media?: AttachmentDto | null;
  splash_background_color?: string;
  splash_dark_background_color?: string;
};

export const initialInterfaceAppearance = {
  system_name: 'EasyPDV',
  primary_color: '#1b84ff',
  sidebar_color: '#0d0e12',
  background_color: '#ffffff',
  logo: null,
  splash_type: { value: SplashScreenType.LOTTIE, description: 'Animação Lottie' },
  splash_media: null,
  splash_background_color: '#ffffff',
  splash_dark_background_color: '#000000',
};
